import _ from "lodash";

export const readProperty = (obj, propPath) => {
  if (!obj || typeof propPath !== "string") {
    return undefined;
  }

  return propPath
    .split(".")
    .reduce((current, prop) => (current ? current[prop] : current), obj);
};

export const toCamelProps = (obj) => {
  if (!obj) {
    return obj;
  }

  return Object.keys(obj).reduce(
    (currentObj, key) => ({ ...currentObj, [_.camelCase(key)]: obj[key] }),
    {}
  );
};
